import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { now, msToDate, differenceInMilliseconds } from 'helpers/DateTimeHelper';

const INTERVAL_MS = 1000;
const MVPDTimer = ({ unixEndTime, expirationCallback }) => {
  useEffect(() => {
    const checkTime = () => {
      const time = differenceInMilliseconds(msToDate(unixEndTime), now());
      if (time <= 0) {
        expirationCallback({ type: 'MVPD' });
        clearInterval(interval);
      }
    };
    const interval = setInterval(() => {
      checkTime();
    }, INTERVAL_MS);
    return () => clearInterval(interval);
  }, [unixEndTime, expirationCallback]);

  return null;
};

export default MVPDTimer;

MVPDTimer.defaultProps = {
  unixEndTime: null,
  expirationCallback: () => {},
};

MVPDTimer.propTypes = {
  unixEndTime: PropTypes.number,
  expirationCallback: PropTypes.func,
};
